import React, { Component } from 'react'
import columns from './columns'
import { SearchBarTable } from 'hljd'
import Store from './store'
import SearchBar from '../SearchBar'
import { Button } from 'hljd'

export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    return (
      <>
        <SearchBar
          store={this.store}
          showTradeType={false}
          timeKey="first_deduct_time"
          extra={<Button onClick={this.store.exportList}>导出明细</Button>}
        />

        <SearchBarTable columns={columns} store={this.store} />
      </>
    )
  }
}
